export const LAND = 'land';
export const RAINWATER = 'rainwater-tank';
export const RECYCLED_WATER = 'recycled-water-system';
export const SERVICE = 'service-v2';
export const SOLAR = 'solar';
export const GEOGRAPHY = 'geography';
export const USAGE = 'usage-v2';
